import { DEFAULT_HOME_PATH, HOME_PATH } from '@/constants/config';
import { FPageNameEnum } from '@/types/pages';
import { FTunnelPageStepEnum } from '@/types/tunnel';
import { createBrowserRouter } from 'react-router-dom';
import ExperiencePage from './ExperiencePage';
import HomePage from './HomePage';
import RootLayout from './RootLayout';
import RouterErrorPage from './RouterErrorPage';
import BookingPage from './tunnel/BookingPage';
import ConfirmationPage from './tunnel/ConfirmationPage';
import TunnelWithContext from './tunnel/TunnelWithContext';
import ValidationPage from './tunnel/ValidationPage';
const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        errorElement: <RouterErrorPage />,
        children: [
            {
                path: '',
                element: <HomePage />
            },
            {
                path: `${FPageNameEnum.experience}/:experienceId`,
                element: <ExperiencePage />
            },
            {
                path: `${FPageNameEnum.tunnel}/:bookingType/`,
                element: <TunnelWithContext />,
                children: [
                    {
                        path: `${FTunnelPageStepEnum.booking}/:experienceId`,
                        element: <BookingPage />
                    },
                    {
                        path: `${FTunnelPageStepEnum.validation}/:experienceId`,
                        element: <ValidationPage />
                    },
                    {
                        path: `${FTunnelPageStepEnum.confirmation}/:experienceId`,
                        element: <ConfirmationPage />
                    }
                ]
            }
        ]
    }
]);
if (DEFAULT_HOME_PATH !== HOME_PATH) {
    // DO NOT CHANGE, "{ replace: true }" FIXES HISTORY AFTER STRIPE REDIRECT
    router.navigate(HOME_PATH, { replace: true });
    // END DO NOT CHANGE
}
export default router;
